import { Calendar } from "primereact/calendar"
import { Dropdown } from "primereact/dropdown"
import { InputNumber } from "primereact/inputnumber"


const Filtros = ({ 
    filtros,
    setFiltros,
    operadores,
    administrativos,
    viaCapturas,
    gasolineras
 }) => {
   
  


    return (
        <div className="vista-combustible-filtros">
            <div className="grupo-filtro">
                <label htmlFor="id">ID</label>
                <InputNumber useGrouping={false} id="id" value={filtros.id} onValueChange={(e) => setFiltros({ ...filtros, id: e.value })} inputClassName="input-full" />
            </div>
            <div className="grupo-filtro">
                <label>Unidad</label>
                <InputNumber useGrouping={false} value={filtros.unidad} onValueChange={(e) => setFiltros({ ...filtros, unidad: e.value })} inputClassName="input-full" />
            </div>
            <div className="grupo-filtro">
                <label>Kilometraje</label>
                <InputNumber useGrouping={false} value={filtros.kilometraje} onValueChange={(e) => setFiltros({ ...filtros, kilometraje: e.value })} inputClassName="input-full" />
            </div>
            <div className="grupo-filtro">
                <label>Folio</label>
                <InputNumber useGrouping={false} value={filtros.folio} onValueChange={(e) => setFiltros({ ...filtros, folio: e.value })} inputClassName="input-full" />
            </div>
            <div className="grupo-filtro">
                <label>Desde</label>
                <Calendar value={filtros.desde} onChange={(e) => setFiltros({ ...filtros, desde: e.value })} showIcon dateFormat="dd/mm/yy" className="input-full" />
            </div>
            <div className="grupo-filtro">
                <label>Hasta</label>
                <Calendar value={filtros.hasta} onChange={(e) => setFiltros({ ...filtros, hasta: e.value })} showIcon dateFormat="dd/mm/yy" className="input-full" />
            </div>
            <div className="grupo-filtro">
                <label>Operador</label>
                <Dropdown optionLabel ="name" value={filtros.operador} onChange={(e) => setFiltros({ ...filtros, operador: e.value })} options={operadores} className="input-full" placeholder="Operador"  filter />
            </div>
            <div className="grupo-filtro">
                <label>Administrativo</label>
                <Dropdown optionLabel ="name" value={filtros.administrativo} onChange={(e) => setFiltros({ ...filtros, administrativo: e.value })} options={administrativos} className="input-full" placeholder="Administrativo"  filter />
            </div>
            <div className="grupo-filtro">
                <label>Gasolinera</label>
                <Dropdown optionLabel ="name" value={filtros.gasolinera} onChange={(e) => setFiltros({ ...filtros, gasolinera: e.value })} options={gasolineras} className="input-full" placeholder="Gasolinera"  filter />
            </div>
            <div className="grupo-filtro">
                <label>Vía Captura</label>
                <Dropdown optionLabel ="name" value={filtros.viaCaptura} onChange={(e) => setFiltros({ ...filtros, viaCaptura: e.value })} options={viaCapturas} className="input-full" placeholder="Vía Captura" filter />
            </div>
        </div>

    )
}
export default Filtros